/**
 * OBSERVER-SCOPE-OPTIONS
 * Assouplissements du périmètre observateur, neutralisés par les accès restreints.
 *
 * Quand la gestion par rôles est active, c'est le rôle qui définit seul le
 * périmètre du tableau de bord : les deux options qui l'élargissent ne sont plus
 * prises en compte. Leurs valeurs restent intactes en base — décocher la gestion
 * par rôles les remet en service telles qu'elles étaient.
 */

import { Session } from "@/redux/_session.types"

//L'observateur voit toute l'organisation, son périmètre n'est qu'un filtre par défaut
export function observersSeeAllResults(session: Session): boolean {
  return !session.accountOptions.roleManagementEnabled && session.accountOptions.observersSeeAllResults
}

//Les attributs de périmètre s'unionnent au lieu de s'intersecter, et les filtres
//choisis par l'observateur deviennent des sous-filtres
export function isObserverNotRestricted(session: Session): boolean {
  return !session.accountOptions.roleManagementEnabled && session.accountOptions.isObserverNotRestricted
}
